module.exports = __webpack_public_path__ + "img/8e1c66f.gif";